import { defineComponent } from "vue";
import sdkNotification from "@/components/sdk-ui/sdk-notification/sdk-notification.vue";
import { parseAccessToken } from "./store/login/actions";

export default defineComponent({
  name: "app",
  components: {
    sdkNotification,
  },
  mounted() {
    this.$store.dispatch(parseAccessToken());
  },
});
